import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TableConfig } from '@app/shared/util/table-config.utils';
import { Group } from "@app/tool/model/group.model";
import { Log } from "ng2-logger";

@Component({
    selector: 'app-tools-table',
    templateUrl: 'tools-table.component.html',
    styleUrls: ['tools-table.component.scss']
})
export class ToolsTableComponent {
    _logger = Log.create(ToolsTableComponent.name);
    @Input() toolsGrouped = new Array<Group>();
    @Input() tableConfig: TableConfig;
    @Input() isLoading = false;
    @Input() treeMode = false;

    @Output() pageChange = new EventEmitter<any>();
    @Output() filterChange = new EventEmitter<any>();
    @Output() groupChange = new EventEmitter<any>();
    @Output() sortChange = new EventEmitter<any>();
    @Output() openDetais = new EventEmitter<any>();

    groupableColumns = [
        {id: 0, name: 'Part number', value: 'PartNumber'},
        {id: 1, name: 'Equipment', value: 'Equipment'},
        {id: 2, name: 'Line', value: 'Line'}];

    filterStatusList = [
        {name: 'All', value: undefined},
        {name: 'Available', value: true},
        {name: 'Not Available', valued: false},
    ];


    constructor() {

    }

    onPageChange(tableConfig: TableConfig) {
        this._logger.info("onPageChange", tableConfig);
        this.pageChange.emit(tableConfig);
    }

    onSortChange(tableConfig: TableConfig) {
        this._logger.info("onSortChange", tableConfig);
        this.sortChange.emit(tableConfig);
    }

    onFilterChange(tableConfig: TableConfig) {
        this._logger.info("onFilterChange", tableConfig);
        this.filterChange.emit(tableConfig);
    }

    onGroupChange(tableConfig: TableConfig) {
        this._logger.info("onGroupChange", tableConfig);
        this.groupChange.emit(tableConfig);
    }

    openToolDetails(tool) {
        this.openDetais.emit(tool);
    }
}
